module.exports = __webpack_public_path__ + "img/shrimp_th_new_0009.902ab67a.png";